// src/common/data/getTypeLabelLongFromSubcategory.ts

import { ITEM_TYPES } from './itemTypes3';

/**
 * Given a raw type_subcategory, return the first matching type_label_long (in raw form).
 * Leaves all translation to the UI layer.
 */
export const getTypeLabelLongFromSubcategory = (subcategory: string): string => {
  const match = ITEM_TYPES.find((item) => item.type_subcategory === subcategory);
  return match?.type_label_long || '';
};
